/** The scroll calls the POS product lists make; FlashListRef satisfies it. */
export type ScrollableProductList = {
  scrollToIndex(params: {
    index: number;
    animated?: boolean;
    viewPosition?: number;
  }): unknown;
  scrollToOffset(params: { offset: number; animated?: boolean }): unknown;
};

type ProductRow = { _id?: string } | null | undefined;

/** Position of a product in the list as rendered (sorted), or -1. */
export const findProductIndex = (
  data: ReadonlyArray<ProductRow> | null | undefined,
  productId: string | null | undefined,
): number => {
  if (!productId || !Array.isArray(data)) return -1;
  return data.findIndex(p => p?._id === productId);
};

/**
 * Brings a product to the top of the list, or scrolls to the top when it is
 * not in the rendered data (no id, or a search is still applied).
 */
export const scrollToProductOrTop = (
  list: ScrollableProductList | null | undefined,
  data: ReadonlyArray<ProductRow> | null | undefined,
  productId: string | null | undefined,
): void => {
  if (!list) return;
  const index = findProductIndex(data, productId);
  if (index >= 0) {
    // FlashList v2 takes the data-array index, even with numColumns > 1.
    void list.scrollToIndex({ index, animated: true, viewPosition: 0 });
  } else {
    void list.scrollToOffset({ offset: 0, animated: true });
  }
};
